/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import QtmColor from './Color';
import common from './common';

const blue: QtmColor = {
  50: '#E2F1FC',
  100: '#B9DCFA',
  200: '#8CC7F7',
  300: '#5EB1F3' /* light */,
  400: '#39A0F1',
  500: '#0691EF',
  600: '#0483E1',
  700: '#0072CE' /* primary */,
  800: '#0060BC',
  900: '#00439D' /* dark */,
  A100: '#C3D7EE',
  A200: '#9DBFE7',
  A400: '#6095DD',
  A700: '#4366B7',
  contrast: {
    50: common.black,
    100: common.black,
    200: common.black,
    300: common.black,
    400: common.black,
    500: common.black,
    600: common.black,
    700: common.white,
    800: common.white,
    900: common.white,
    A100: common.black,
    A200: common.black,
    A400: common.black,
    A700: common.white,
  },
};

export default blue;
